import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import Stack from '../../../stack';

export const squareColors = [
    {
        backgroundColor: 'error-red-main',
        borderColor: 'error-red-main',
        color: '#dc3122',
    },
    {
        backgroundColor: 'myzanichelli-blue-main',
        borderColor: 'myzanichelli-blue-main',
        color: '#0056c1',
    },
    {
        backgroundColor: 'success-green-main',
        borderColor: 'success-green-main',
        color: '#417505',
    },
    {
        backgroundColor: 'warning-yellow-main',
        borderColor: 'warning-yellow-main',
        color: '#f6bb3b',
    },
    {
        backgroundColor: 'surface-grey-800',
        borderColor: 'text-grey-800',
        color: '#424548',
    },
];

const ColorContainer = styled.div`
    position: absolute;
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors['surface-white']};
    padding: 4px;
    box-shadow: ${(props) => props.theme.shadows['shadow-02dp']};
`;

export const Square = styled.button`
    display: block;

    ${({ theme, backgroundColor, borderColor }) => css`
        border: 1px solid ${theme.colors[borderColor]};
        border-radius: 1px;
        width: 16px;
        height: 16px;
        background-color: ${theme.colors[backgroundColor]};
        outline: none;
        cursor: pointer;
        padding: 0;

        &:hover {
            box-shadow: ${theme.shadows['shadow-02dp']};
        }

        &:focus {
            box-shadow: ${theme.shadows['outline']};
        }
    `};
`;

export const SquareColor = ({ lightColor, darkColor, onClick }) => {
    return <Square borderColor={darkColor} backgroundColor={lightColor} onClick={onClick} />;
};

SquareColor.propTypes = {
    lightColor: PropTypes.string,
    darkColor: PropTypes.string,
    onClick: PropTypes.func,
};

const ColorPopover = ({ setColor }) => {
    return (
        <ColorContainer>
            <Stack gap="median" direction="horizontal">
                {squareColors.map((square, index) => (
                    <SquareColor
                        key={index}
                        darkColor={square.borderColor}
                        lightColor={square.backgroundColor}
                        onClick={() => setColor(square.color)}
                    />
                ))}
            </Stack>
        </ColorContainer>
    );
};

ColorPopover.propTypes = {
    setColor: PropTypes.func,
};

export default ColorPopover;
